import { Button, Paper, useTheme } from "@mui/material";
import useKeyboardVisible from "../../../../hooks/ui-states/useKeyboardVisible";

interface SubmitButtonProps {
  isUpdate: boolean;
  disabled: boolean;
  isDrawer?: boolean;
  submitLabel: string;
  updateLabel: string;
  onClick: () => void;
}

const SubmitButton = ({
  isUpdate,
  disabled,
  isDrawer = false,
  submitLabel,
  updateLabel,
  onClick,
}: SubmitButtonProps) => {
  const theme = useTheme();
  const { isKeyboardVisible, isReady } = useKeyboardVisible();

  // When keyboard is visible, use relative positioning so button scrolls with content
  if (isReady && isKeyboardVisible) {
    return (
      <Paper
        sx={{
          width: "100%",
          position: "relative",
          backgroundColor: "transparent",
          borderRadius: 0,
          padding: 2,
          paddingBottom: 2,
        }}
        elevation={0}
      >
        <Button
          fullWidth
          type="submit"
          variant="contained"
          disabled={disabled}
          color="primary"
          size="large"
          onClick={onClick}
        >
          {isUpdate ? updateLabel : submitLabel}
        </Button>
      </Paper>
    );
  }

  // When keyboard is hidden, use fixed positioning at the bottom
  return (
    <Paper
      sx={{
        right: 0,
        bottom: "env(safe-area-inset-bottom, 0px)",
        width: "100%",
        position: "fixed",
        backgroundColor: "transparent",
        [theme.breakpoints.down('sm')]: {
          left: 0,
          width: "100%",
        },
        [theme.breakpoints.up('md')]: {
          left: !isDrawer ? theme.mixins.sidebar.width : "auto",
          width: !isDrawer ? `calc(100% - ${theme.mixins.sidebar.width}px)` : "400px",
        },
        borderRadius: 0,
        zIndex: theme.zIndex.drawer - 1,
        padding: 2,
        paddingBottom: "calc(env(safe-area-inset-bottom, 0px) + 16px)",
      }}
      elevation={0}
    >
      <Button
        fullWidth
        type="submit"
        variant="contained"
        disabled={disabled}
        color="primary"
        size="large"
        onClick={onClick}
      >
        {isUpdate ? updateLabel : submitLabel}
      </Button>
    </Paper>
  );
};

export default SubmitButton;
